import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminVariables({ csrfToken }) {
  const [variables, setVariables] = useState([]);
  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editValue, setEditValue] = useState("");
  const [error, setError] = useState("");

  const headers = { "Content-Type": "application/json", "CSRF-Token": csrfToken };

  useEffect(() => {
    fetch(`${API}/admin/variables`, { credentials: "include" })
      .then(r => r.json())
      .then(setVariables);
  }, []);

  const add = async () => {
    setError("");
    if (!newKey.trim()) return;
    const res = await fetch(`${API}/admin/variables`, {
      method: "POST", credentials: "include", headers,
      body: JSON.stringify({ key: newKey.trim(), value: newValue })
    });
    if (!res.ok) { const d = await res.json(); setError(d.error); return; }
    const v = await res.json();
    setVariables(prev => [...prev, v].sort((a, b) => a.key.localeCompare(b.key)));
    setNewKey(""); setNewValue("");
  };

  const saveEdit = async (id) => {
    const res = await fetch(`${API}/admin/variables/${id}`, {
      method: "PUT", credentials: "include", headers,
      body: JSON.stringify({ value: editValue })
    });
    const v = await res.json();
    setVariables(prev => prev.map(x => x._id === id ? v : x));
    setEditingId(null);
  };

  const remove = async (id) => {
    if (!window.confirm("Variabele verwijderen?")) return;
    await fetch(`${API}/admin/variables/${id}`, { method: "DELETE", credentials: "include", headers });
    setVariables(prev => prev.filter(x => x._id !== id));
  };

  return (
    <div>
      <h2>Variabelen</h2>
      <p className="note">Gebruik <code>{"{key}"}</code> in titels en inhoud van contentpagina&apos;s om de waarde in te voegen.</p>

      <table className="variables-table">
        <thead>
          <tr><th>Sleutel</th><th>Waarde</th><th></th></tr>
        </thead>
        <tbody>
          {variables.map(v => (
            <tr key={v._id}>
              <td><code>{v.key}</code></td>
              <td>
                {editingId === v._id ? (
                  <input
                    value={editValue}
                    onChange={e => setEditValue(e.target.value)}
                    onKeyDown={e => e.key === "Enter" && saveEdit(v._id)}
                    autoFocus
                  />
                ) : v.value}
              </td>
              <td className="variables-actions">
                {editingId === v._id ? (
                  <>
                    <button onClick={() => saveEdit(v._id)}>Opslaan</button>
                    <button className="btn-secondary" onClick={() => setEditingId(null)}>Annuleren</button>
                  </>
                ) : (
                  <>
                    <button className="btn-secondary" onClick={() => { setEditingId(v._id); setEditValue(v.value); }}>Bewerken</button>
                    <button className="btn-danger" onClick={() => remove(v._id)}>×</button>
                  </>
                )}
              </td>
            </tr>
          ))}
          <tr className="variables-new-row">
            <td>
              <input
                value={newKey}
                onChange={e => setNewKey(e.target.value)}
                placeholder="sleutel"
                onKeyDown={e => e.key === "Enter" && add()}
              />
            </td>
            <td>
              <input
                value={newValue}
                onChange={e => setNewValue(e.target.value)}
                placeholder="waarde"
                onKeyDown={e => e.key === "Enter" && add()}
              />
            </td>
            <td><button onClick={add}>+ Toevoegen</button></td>
          </tr>
        </tbody>
      </table>
      {error && <p className="content-error">{error}</p>}
    </div>
  );
}
